<template>
  <div v-if="isLoggedIn" class="balance-details hidden-md-and-up">
    <v-row no-gutters class="balanceRow py-2">
    <!--     prod conflict css :  column-padding -->
      <v-col cols="5" class="pa-0">
        <v-row no-gutters>
          <!--     prod conflict css :  memberCodeName -->
          <v-col :class="$vuetify.breakpoint.mdAndUp ? '' : 'balance'">Hi, {{ memberInfo.memberCode }}</v-col>
        </v-row>
        <v-row no-gutters class="hidden-sm-and-down">
          <v-col>{{ memberWallet.totalBalance | currency(currentCurrency) }}</v-col>
        </v-row>
        <v-row no-gutters class="d-flex align-center hidden-md-and-up">
          <v-col class="pa-0 d-flex align-center justify-space-between memberBalance">
            <div>
<!--              <img src="/static/svg/wallet.svg" />-->
              <label class="text-capitalize balance" v-if="notLoading">
                <span v-if="showBalance">{{ memberWallet.totalBalance | currency(currentCurrency) | maskNumber }}</span>
                <span v-else>{{ memberWallet.totalBalance | currency(currentCurrency) }}</span>
              </label>
              <v-progress-circular indeterminate v-if="!notLoading" color="amber" :width="3" :size="24"></v-progress-circular>
            </div>
            <div v-if="notLoading" @click="getMemberWallet()" class="refresh-balance-icon"></div>
          </v-col>

          <!--          <div class="justify-end" @click="getMemberWallet()">-->
          <!--            <v-icon v-if="showBalance" class="mask-balance">mdi-eye-off</v-icon>-->
          <!--            <v-icon v-else class="mask-balance">mdi-eye-settings</v-icon>-->
          <!--          </div>-->
          <!--          <v-col>{{ memberWallet.totalBalance | currency(currentCurrency) }}</v-col>-->
        </v-row>
      </v-col>
      <!--   first draft design   -->
      <!--      <v-col cols="6" class="nav-container">-->
      <!--        <div class="mx-auto nav-wrapper">-->
      <!--          <v-card class="nav-item" :to="{ name: routeName.VIP }">-->
      <!--            <img class="img-nav-item" :src="`/static/svg/mobileMemberBalance/bettingPass.svg`" />-->
      <!--          </v-card>-->
      <!--          <span class="nav-item-span">{{ $t(`mobileMenuTitle.bettingPass`) }}</span>-->
      <!--        </div>-->
      <!--        <div class="mx-auto nav-wrapper">-->
      <!--          <v-card class="nav-item" :to="{ name: routeName.REWARDS }">-->
      <!--            <img class="img-nav-item" :src="`/static/svg/mobileMemberBalance/rewards.svg`" />-->
      <!--          </v-card>-->
      <!--          <span class="nav-item-span">{{ $t(`mobileMenuTitle.rewards`) }}</span>-->
      <!--        </div>-->
      <!--        <div class="mx-auto nav-wrapper">-->
      <!--          <v-card class="nav-item" :to="{ name: routeName.TRANSACTION_HISTORY }">-->
      <!--            <img class="img-nav-item" :src="`/static/svg/mobileMemberBalance/betHistory.svg`" />-->
      <!--          </v-card>-->
      <!--          <span class="nav-item-span">{{ $t(`mobileMenuTitle.betHistory`) }}</span>-->
      <!--        </div>-->
      <!--        <div class="mx-auto nav-wrapper">-->
      <!--          <v-card class="nav-item" :to="{ name: routeName.WITHDRAWAL }">-->
      <!--            <img class="img-nav-item" :src="`/static/svg/mobileMemberBalance/withdrawal.svg`" />-->
      <!--          </v-card>-->
      <!--          <span class="nav-item-span">{{ $t(`mobileMenuTitle.withdrawal`) }}</span>-->
      <!--        </div>-->
      <!--      </v-col>-->
      <!--  2nd draft design    -->
      <v-col cols="7" class="d-flex align-center">
        <v-row no-gutters class="justify-end" style="gap: 15px">
          <!--          <div>-->
          <!--            <v-card dark class="nav-item" :to="{ name: routeName.VIP, params: { lang: this.$route.params.lang } }">-->
          <!--              <img class="img-nav-item" :src="`/static/svg/mobileMemberBalance/bettingPass.svg`" />-->
          <!--            </v-card>-->
          <!--            <span class="nav-item-span">{{ $t(`mobileMenuTitle.bettingPass`) }}</span>-->
          <!--          </div>-->
          <!--          <div>-->
          <!--            <v-card dark class="nav-item" @click="goToRewards">-->
          <!--              <img class="img-nav-item" :src="`/static/svg/mobileMemberBalance/rewards.svg`" />-->
          <!--            </v-card>-->
          <!--            <span class="nav-item-span">{{ $t(`mobileMenuTitle.rewards`) }}</span>-->
          <!--          </div>-->

          <div v-if="parent.toString() == this.routeName.MOBILE_ACCOUNT">
            <v-card dark class="nav-item" :to="{ name: routeName.REFERRAL_SUMMARY, params: { lang: this.$route.params.lang } }">
              <img class="img-nav-item" :src="`/static/svg/mobileMemberBalance/referral.svg`" />
            </v-card>
            <span class="nav-item-span">{{ $t(`label.referral`) }}</span>
          </div>
          <div>
            <v-card dark class="nav-item" :to="{ name: routeName.DEPOSIT, params: { lang: this.$route.params.lang } }">
              <img class="img-nav-item" :src="`/static/svg/mobileMemberBalance/newDeposit.svg`" />
            </v-card>
            <span class="nav-item-span">{{ $t(`mobileMenuTitle.deposit`) }}</span>
          </div>
          <div>
            <v-card dark class="nav-item" :to="{ name: routeName.WITHDRAWAL, params: { lang: this.$route.params.lang } }">
              <img class="img-nav-item" :src="`/static/svg/mobileMemberBalance/newWithdrawal.svg`" />
            </v-card>
            <span class="nav-item-span">{{ $t(`mobileMenuTitle.withdrawal`) }}</span>
          </div>
          <div v-if="parent.toString() == this.routeName.HOME">
            <v-card dark class="nav-item" :to="{ name: routeName.MOBILE_BETTING_HISTORY, params: { lang: this.$route.params.lang } }">
              <img class="img-nav-item" :src="`/static/svg/mobileMemberBalance/betHistory.svg`" />
            </v-card>
            <span class="nav-item-span">{{ $t(`label.history`) }}</span>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { uiHelper } from '@/util'
import { ROUTE_NAME } from '@/constants/route.constants'
import { MEMBER_WALLET } from '@/store/member.module'

export default {
  name: 'MemberBalance',
  data: () => ({
    notLoading: true,
    showBalance: true,
    walletBalance: 0,
    routeName: ROUTE_NAME,
    currentCurrency: uiHelper.getCurrency()
  }),
  props: {
    parent: {
      type: String,
      required: true,
      default: ''
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    memberInfo() {
      return this.$store.state.member.info
    },
    memberWallet() {
      return this.$store.state.member.walletBalance
    }
  },
  watch: {
    memberWallet() {
      this.notLoading = true
    }
  },
  methods: {
    goToRewards() {
      let routeName = (this.currentCurrency === 'BDT' || this.currentCurrency === 'NPR') ? ROUTE_NAME.REWARD_STORE_ITEM : ROUTE_NAME.REWARDS
      this.$router.push({ name: routeName, params: { lang: this.$route.params.lang } })
    },
    getMemberWallet() {
      if (!this.lastDispatchTime || Date.now() - this.lastDispatchTime > 15 * 1000) {
        this.notLoading = false
        this.lastDispatchTime = Date.now() // Update last dispatch time
        this.$store.dispatch(MEMBER_WALLET)
      }
      this.maskBalance()
    },
    maskBalance() {
      this.showBalance = !this.showBalance
    }
  }
}
</script>

<style scoped lang="scss">
.memberBalance {
  box-shadow: 0px 0px 4px 0px #00000040 inset;
  border-radius: 5px;
  background: white;
  height: 30px;
  padding: 0 10px !important;


}
.balanceRow {
  background-color: #f3f5f6;
  padding: 10px;
}
.column-padding {
  padding: 8px !important;
}
.refresh-balance-icon {
  width: 20px;
  height: 20px;
  background-color: #ffce01;
  mask: url(/static/image/profile/icon-refresh-type01.svg);
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask: url(/static/image/profile/icon-refresh-type01.svg);
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  cursor: pointer;
}
.nav-wrapper {
  min-width: auto;
}

.balance-details {
  height: 100px;
  padding-top: 12px;
}
.nav-container {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  /*justify-content: space-evenly;*/
}
.nav-item {
  display: flex;
  width: 3rem;
  height: 3rem;
  background-color: #333333;
  border-radius: 10px;
  margin: 0 10px 3px 10px;
}
.nav-item-span {
  font-size: 0.825rem;
  display: inline-block;
  width: 100%;
  text-align: center;
}

.img-nav-item {
  margin: auto;
  width: 2rem;
  height: 2rem;
}

@media (max-width: 599px) {
  .nav-item-span {
    font-size: 0.8rem;
  }
  .nav-item {
    width: 3rem;
    height: 3rem;
    margin: auto;
  }
  .img-nav-item {
    width: 2rem;
    height: 2rem;
  }
}
@media (max-width: 429px) {
  .memberCodeName {
    font-size: 12px;
  }
  .balance {
    font-size: 11px;
  }
  .refresh-balance-icon {
    width: 15px;
    height: 15px;
  }
  .balance-details {
    height: 75px !important;
  }
  .nav-item-span {
    font-size: 0.625rem;
  }
  .nav-item {
    width: 2rem;
    height: 2rem;
    margin: auto;
  }
  .img-nav-item {
    width: 1.5rem;
    height: 1.5rem;
  }
}

@media (max-width: 330px) {
  .column-padding {
    padding: 2px !important;
  }
  .memberCodeName {
    font-size: 10px;
  }
  .balance {
    font-size: 10px;
  }
  .nav-item-span {
    font-size: 0.525rem;
  }
  .nav-item {
    width: 2rem;
    height: 2rem;
    margin: auto;
  }
  .img-nav-item {
    width: 1.5rem;
    height: 1.5rem;
  }
}
@media (max-width: 250px) {
  .column-padding {
    padding: 2px !important;
  }
  .memberCodeName {
    font-size: 8px;
  }
  .balance {
    font-size: 8px;
  }
  .nav-item-span {
    font-size: 0.525rem;
  }
  .nav-item {
    width: 1.8rem;
    height: 1.8rem;
    margin: auto;
  }
  .img-nav-item {
    width: 1.5rem;
    height: 1.5rem;
  }
}
</style>
